var processInclude = require("base/util");

// import the contact us file from core
require("coremh/contactUs");

// importVCP specific files
$(document).ready(function () {
    processInclude(require("coremh/thirdParty/jquery.bs.calendar"));
    processInclude(require("coremh/components/customContactUs"));
});
